// extracted by mini-css-extract-plugin
module.exports = {"settings-container":"lCdn_B3IN-gthfIfxx0PO"};